import {
  req,
  ref,
  withParams
} from 'vuelidate/lib/validators/common';

export default equalTo => withParams(
  {type: 'sameAs', eq: equalTo},
  function (value, parentVm) {
    return !req(value) || value === ref(equalTo, this, parentVm);
  }
);